<template>
    <div class="container">
        <content-header title="Нарушения пищевого поведения"/>
        <article-detail-component :data="detail"/>
<!--        <comment-form id="comment-form" slug="нарушения-пищевого-поведения" class="comment-wrapper"/>-->
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";
import CommentForm from "@/components/CommentForm";
import ArticleDetailComponent from "@/components/ArticleDetailComponent";

export default {
    components: {
        ContentHeader,
        CommentForm,
        ArticleDetailComponent
    },
    data() {
        return {
            detail: {
                created: '07 АВГ 19',
                title: 'Нарушения пищевого поведения',
                description: `

<p style="margin-bottom: 20px"><img src="http://staging-5-clinic.ru/wp-content/uploads/2019/08/NEWS_025.jpg" alt="" width="480" height="320"></p>
<p align="justify"><strong>Психотерапия – важная часть лечения ожирения</strong><br>
Избыточная масса тела и ожирение – междисциплинарная проблема, которой занимаются не только <strong>эндокринологи</strong> и <strong>терапевты</strong>, но и <strong>диетологи</strong>, <strong>неврологи</strong>, <strong>психиатры</strong>, <strong>психологи</strong>. Это связано со следующими обстоятельствами:<br>
1. В основе повышения массы тела лежат не только эндокринно-метаболические расстройства, но и нейромедиаторная дисфункция ЦНС, <strong>психологические нарушения</strong>.<br>
2. Среди этиологических факторов ожирения значительное место занимают острый и хронический <strong>эмоциональный стресс</strong>.<br>
3. Формирование патологических типов пищевого поведения неразрывно связано с <strong>нарушениями</strong> всей мотивационной системы и другими <strong>эмоционально-личностными особенностями</strong> индивидуума.<br>
4. Ожирение всегда сопряжено со значительными изменениями внешнего облика человека, что порождает <strong>психологический дискомфорт</strong> и может приводить к формированию вторичных эмоционально-личностных расстройств.<br>
5. Ожирение значительно <strong>ухудшает качество жизни</strong> человека.<br>
При исследовании больного ожирением особое внимание следует уделять расстройствам пищевого поведения, от характера которых во многом зависит будущая терапия.<br>
Три основных типа нарушения пищевого поведения: экстернальное, эмоциогенное и ограничительное.<br>
<strong>Экстернальное</strong> пищевое поведение проявляется повышенной реакцией больного не на внутренние стимулы к приему пищи (истинное чувство голода связанное с уровнем глюкозы и свободных жирных кислот в крови, наполненностью желудка и его моторикой и т.д.), а на внешние, такие как вид еды или жующего человека, реклама пищевых продуктов и т.д. При подобном типе пищевого поведения определяющее значение имеет доступность продуктов. Практически у всех пациентов с ожирением в той или иной степени выражено экстернальное пищевое поведение.<br>
<strong>Эмоциогенное</strong> пищевое поведение встречается у 60% больных ожирением. Стимулом к приему пищи становиться не голод, а эмоциональный дискомфорт: человек ест не потому что голоден, а потому что он неспокоен, тревожен, раздражен, у него плохое настроение, он удручен, подавлен, обижен, раздосадован, разочарован, потерпел неудачу, ему скучно, одиноко и т.д. У этого типа нарушения пищевого поведения есть другие названия – гиперфагическая реакция на стресс, эмоциональное переедание или «пищевое пьянство».<br>
Эмоциогенное пищевое поведение может быть представлено компульсивным пищевым поведением – приступами переедания. Потеря контроля приема пищи – важный диагностический признак компульсивных приступов. Другой вариант эмоциогенного пищевого поведения – переедание с нарушением суточного ритма приема пищи (синдром ночной еды).<br>
Эмоциогенное пищевое поведение может наблюдаться в рамках сезонных аффективных расстройств, их главным отличительным признаком является возникновение клинических симптомов исключительно в темное время года (в нашей географической зоне – с конца октября по начало марта) и самопроизвольное исчезновение в светлое время года. Главным клиническим симптомом является депрессия, отсюда и название синдрома – зимняя депрессия.<br>
<strong>Ограничительное</strong> пищевое поведение – хаотичные, резкие самоограничения приема пищи, которые не выдерживаются больным длительное время, что ведет к декомпенсации в психической и вегетативной сферах. Эмоциональная нестабильность, возникающая в результате применения строгих диет, получила название «диетическая депрессия».<br>
Увеличение массы тела – следствие воздействия множества причин, выявление и ликвидация которых помогает избавиться от лишнего жира. Другими словами, ожирение является многофакторным заболеванием. Справиться с отклонением удастся только в том случае, если правильно определить причину и подобрать соответствующее лечение.<br>
<strong>Психологические причины полноты у женщин</strong><br>
Представительницам прекрасного пола нужны новые впечатления и эмоции, в противном случае, повседневная рутина провоцирует сильное недовольство жизнью. Можно выделить следующие метафизические причины тучности у дам:<br>
1. Изменение социального статуса – замужество. Женщина поправляется, если уверена в том, что хранительница домашнего очага должна выглядеть солидно.<br>
2. Исполнение роли кормильца семьи. Когда замужняя женщина занимается выполнением тех задач, которые должен решать мужчина, организм помогает увеличить работоспособность, запасая жир.<br>
3. Отрицание собственной женственности и сексуальности. Наличие подобных женских проблем приводит к тому, что жировые накопления появляются в области живота, а также полнеют бедра.<br>
4. Отсутствие должного интереса со стороны мужа. Женщине постоянно нужны знаки внимания, иначе она начинает себя ощущать совершенно непривлекательной и незаметной. Исправить ситуацию помогает полнота, особенно если мужчина считает пышных дам красивыми.<br>
Многие женщины расслабляются после длительного и тяжелого трудового дня с помощью еды. Калорийная пища помогает забыть о пережитых неприятностях. А поскольку в вечернее время метаболизм замедляется, подобные действия рано или поздно приводят к образованию жировых складок.<br>
<strong>Социальные факторы</strong><br>
В данном случае, подразумевается влияние окружения на пищевое поведение человека.<br>
Подобное воздействие можно охарактеризовать следующим образом:<br>
1. Если в семье дети с малых лет привыкают к изобилию блюд на столе, особенно, различных сладостей, со временем они зачастую имеют серьезные проблемы с весом.<br>
2. Наличие в магазинных продуктах усилителей вкуса и добавок приводит к тому, что человек съедает больше положенного. Кроме того, на выбор покупателей воздействуют различные маркетинговые хитрости в виде подходящей музыки, ароматов, расстановки продукции на полках и всевозможных акций.<br>
3. Большинство людей не представляют общения с друзьями и близкими без посиделок за накрытым столом, особенно во время праздников. Закуски и спиртные напитки – частые атрибуты при подписании контрактов.<br>
Решение проблемы ожирения носит комплексный подход, в основе которого так же лежит психолого-психотерапевтическая помощь.<br>
Для достижения оптимальных результатов лечения ожирения при назначении терапевтических программ необходимо учитывать типологию нарушений пищевого поведения, эмоционально-личностных и психовегетативных расстройств у пациента.</p>
<p><strong>Запись по телефону:&nbsp; &nbsp;</strong> <a href="+74956208107"><strong>+7 (495) 620-81-07</strong></a></p>

            `
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: center;
    width: 225px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

.link {
    color: #006688;
    border-bottom: 1px dotted #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
}

.left-30px {
    margin-left: 30px;
}

hr {
    display: block;
    unicode-bidi: isolate;
    margin-block-start: 0.5em;
    margin-block-end: 0.5em;
    margin-inline-start: auto;
    margin-inline-end: auto;
    overflow: hidden;
    border-style: inset;
    border-width: 1px;
    color: #666;
    line-height: 1;
}

</style>

<style lang="scss" scoped>
.article-detail {
    display: flex;
    margin-top: 30px;

    .comment_box {
        width: 100px;
        display: flex;
        align-items: center;
        margin-bottom: 25px;
        flex-direction: column;

        .date {
            width: 100%;
            position: relative;
        }

        .date .value {
            background-color: #006688;
            color: #fff;
            padding: 10px 13px;
            font-size: 12px;
            width: 100%;

            @media screen and (max-width: 768px) {
                padding: 10px 10px;
            }
        }

        .comments_number {
            width: 100%;
            margin-top: 4px;
            background-color: #00b6cc;
            padding: 10px 12px;
            color: #fff;
            font-size: 12px;
        }

        .arrow_date {
            content: '';
            top: 0;
            right: -4px;
            display: inline;
            border-color: #006688 transparent;
            visibility: visible;
            position: absolute;
            border-style: solid;
            border-width: 5px 5px 0 0;
        }
    }


    &__content {
        margin-left: 20px;
        border-bottom: 1px solid #E0E0E0;
    }

    &__title {
        text-align: left;

    }

    @media screen and (max-width: 450px) {

        &__title {
            h2 {
                font-size: 18px;
            }

        }
    }

    &__image {
        width: 60%;

        img {
            width: 100%;
            margin: 5px 20px 20px 0;
        }
    }

    &__desc {

        p {
            text-align: left;
            font-size: 14px;
        }

        .more-detail {
            font-size: 14px;
            margin: 15px 0;
        }

        .routes {
            margin: 15px 0;
        }
    }
}

.comment-wrapper {
    margin-left: 120px;
    margin-top: 30px;
    padding: 10px;

    @media screen and (max-width: 570px) {
        margin-left: 0;
    }
}
</style>

<style>
.article-detail__content {
    width: 100% !important;
}
</style>
